<script setup lang="ts">
import { type ArticoloRivista } from "@gasparigit/omnia-sdk";
import { link } from "~/lib/utils/contents";

defineProps<{
  content: ArticoloRivista;
  compact?: boolean;
  showAreas?: boolean;
}>();
</script>

<template>
  <FrontContentItemsBaseContent v-bind="$props">
    <template #preview v-if="content.capitolo?.numero_rivista">
      <div class="font-monospace flex flex-col items-start justify-center text-base pe-4 border-e-2 border-primary mb-2 md:mb-0">
        <span class="text-2xl text-primary font-semibold">{{ content.capitolo.numero_rivista.number }}</span>
        <template v-if="content.capitolo.numero_rivista.published_at">
          <span>{{ content.capitolo.numero_rivista.published_at.toLocaleString("default", { month: "long" }) }}</span>
          <span>{{ content.capitolo.numero_rivista.published_at.getFullYear() }}</span>
        </template>
      </div>
    </template>
    <template #info v-if="content.overtitle">
      <span class="info-number mt-2 md:mt-0">{{ content.overtitle }}</span>
    </template>
    <template #header v-if="content.capitolo?.numero_rivista?.rivista">
      <NuxtLink :to="link({ rivista: content.capitolo?.numero_rivista.rivista, numeroRivista: content.capitolo?.numero_rivista })" class="text-primary font-semibold mb-1">
        {{ content.capitolo.numero_rivista.rivista.title }}
      </NuxtLink>
    </template>
    <template #center v-if="content.author">
      <span class="text-themeGray font-thin mt-3">A cura di {{ content.author }}</span>
    </template>
  </FrontContentItemsBaseContent>
</template>
